export default "__VITE_ASSET__D18NT$Ke__"